import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {BehaviorSubject, Observable} from "rxjs";
import {userModel} from "../../../shared/model/user.model";
import {SidebarService} from "../sidebar/sidebar.service";

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  public currentUserSubject = new BehaviorSubject<userModel | null>(null);
  private currentUser!: Observable<any | null>;

  public currentUrlsSubject: BehaviorSubject<string [] | null> = new BehaviorSubject<string [] | null>(null);
  private currentMenusSubject: BehaviorSubject<any [] | null> = new BehaviorSubject<any [] | null>(null);


  constructor(
    private router: Router,
    private sidebar: SidebarService,
  ) {
    this.currentUserSubject = new BehaviorSubject<any | null>(null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public setUser(user: userModel): void {
    if (user.role == 'ADMIN'){
      this.currentMenusSubject.next(this.sidebar.adminMenu);
    }else if (user.role == 'MANAGER'){
      this.currentMenusSubject.next(this.sidebar.managerMenu);
    }else if (user.role == 'SUBSCRIBER'){
      this.currentMenusSubject.next(this.sidebar.subscriberMenu);
    }
    this.currentUserSubject.next(user);
  }

  // Observable: use this to subscribe to user data
  public getUser(): Observable<userModel | null> {
    return this.currentUserSubject.asObservable();
  }

  // Synchronous value: use this to get user data immediately (e.g. in guards)
  public getUserOnce(): userModel | null {
    return this.currentUserSubject.getValue();
  }
  public getCurrentUser(): userModel | null {
    return this.currentUserSubject.value;
  }
  // Optional: clear user (e.g. on logout)
  public clearUser(): void {
    this.currentUserSubject.next(null);
  }

  private findUrl(url: string): boolean {
    if (this.currentUrlsSubject.getValue() && this.currentUserSubject.getValue()) {
      return <boolean>this.currentUrlsSubject?.getValue()
          ?.some(el => el === url
              || el === url.replace(/\/[a-z0-9]+$/i, '') || el == url.replace(/\?.*$/, ''));
    } else {
      return false;
    }
  }

  isValidMenu(url: string): boolean | undefined {
    return this.findUrl(url)
  }

  getCurrentUserMenu() {
    return this.currentMenusSubject.asObservable();
  }
  getCurrentUserRole():string{
    return  this.currentUserSubject.getValue()?.role || '';
  }

}
